import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router/composables'

import LCard from '@/components/core/card/Card.vue'
import LCardHeader from '@/components/core/card/CardHeader.vue'
import LCardTitle from '@/components/core/card/CardTitle.vue'
import LCardContent from '@/components/core/card/CardContent.vue'
import {
  useSetTokens,
  useAuthenticateWithFacebook,
  usePendingActions,
} from '@/composables/auth'
import { useMcpAuth } from '@/composables/mcp-auth'
import { useContext } from '@/composables/context'
import { authModule, eventModule } from '@/store'
import { SocialLoginType } from '@/utils/enums'
import { loadScript, logEvent } from '@/utils/utility-manager'

declare global {
  interface Window {
    FB: typeof FB
  }
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SingleSignOnFacebook',
  props: {
    mode: null
  },
  setup(__props: any) {

const props = __props as {
  mode: 'sign_up' | 'sign_in'
};



const { i18n } = useContext()
const router = useRouter()

const { mutate: authenticateWithFacebook } = useAuthenticateWithFacebook()
const { setTokens } = useSetTokens()
const { handlePendingActions, getPendingActionsType } = usePendingActions()
const { completeMcpAuth } = useMcpAuth()

const showAdblockHint = ref(false)

onMounted(() => {
  loadScript('fb-sdk', 'https://connect.facebook.net/de_DE/sdk.js', () => {
    window.FB.init({
      appId: process.env.FB_APP_ID,
      cookie: true,
      xfbml: true,
      version: 'v25.0',
    })
  })
})

function loginFacebook() {
  if (!window.FB) {
    showAdblockHint.value = true
    return
  }

  try {
    window.FB.login(
      (loginResponse: fb.StatusResponse) => {
        if (!loginResponse.authResponse) {
          eventModule.newError('error.login.facebook')
          return
        }
        window.FB.api('/me', { fields: ['email'] }, (graphResponse) => {
          if (loginResponse.authResponse.accessToken && graphResponse.email) {
            authenticateWithFacebook(
              {
                fbAccessToken: loginResponse.authResponse.accessToken,
                email: graphResponse.email,
                locale: i18n.locale as string,
                isDemo: authModule.loggedIn && authModule.user.isDemo,
              },
              {
                async onSuccess(response) {
                  logEvent(
                    props.mode === 'sign_in'
                      ? 'logged_in'
                      : 'registration_success',
                    {
                      method: 'facebook',
                      onboarding_events: getPendingActionsType(),
                    },
                  )

                  if (await completeMcpAuth(response)) return

                  setTokens(response, SocialLoginType.FACEBOOK)
                  const redirectPath = await handlePendingActions()
                  router.push({ path: redirectPath ?? '/' })
                },
              },
            )
          } else {
            eventModule.newError('error.login.facebook')
          }
        })
      },
      { scope: 'email' },
    )
  } catch (error) {
    eventModule.newError('error.login.facebook')
  }
}

return { __sfc: true,props, i18n, router, authenticateWithFacebook, setTokens, handlePendingActions, getPendingActionsType, completeMcpAuth, showAdblockHint, loginFacebook, LCard, LCardHeader, LCardTitle, LCardContent }
}

})